import React from "react";
import { Wrench, Phone, Mail, Shield } from "lucide-react";
import Logo from "@/components/Logo";

export default function MaintenancePage({ message, contact }) {
  const phone = (contact || "+91 9582233820").trim();
  const tel = phone.replace(/[^0-9+]/g, "");
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#0B1120] via-[#1E3A8A] to-[#0B1120] text-white flex items-center justify-center px-4 py-10 relative overflow-hidden" data-testid="maintenance-page">
      {/* Decorative blobs */}
      <div className="absolute -top-32 -left-32 w-96 h-96 bg-[#F59E0B]/20 rounded-full blur-3xl" />
      <div className="absolute -bottom-32 -right-32 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl" />

      <div className="relative max-w-2xl w-full text-center">
        <div className="flex justify-center mb-8">
          <Logo size={56} textClassName="text-white" />
        </div>

        <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-[#F59E0B]/20 border-2 border-[#F59E0B] mb-6 animate-pulse">
          <Wrench size={42} className="text-[#F59E0B]" />
        </div>

        <h1 className="heading text-4xl sm:text-5xl font-black mb-4">Under Maintenance</h1>
        <p className="text-blue-100 text-lg leading-relaxed mb-8 max-w-xl mx-auto">
          {message || "Site is currently under maintenance. We're working hard to bring it back online soon."}
        </p>

        <div className="bg-white/5 backdrop-blur-md border border-white/10 rounded-2xl p-6 sm:p-8 max-w-md mx-auto" data-testid="maintenance-contact-box">
          <div className="text-xs font-black uppercase tracking-[0.25em] text-[#F59E0B] mb-3">Need Assistance?</div>
          <p className="text-sm text-blue-100 mb-5">Kindly contact the developer for any urgent help.</p>

          <a
            href={`tel:${tel}`}
            className="flex items-center justify-center gap-3 bg-[#F59E0B] hover:bg-[#D97706] text-black font-black rounded-xl py-3 px-6 transition shadow-lg shadow-amber-500/30"
            data-testid="maintenance-call-button"
          >
            <Phone size={18} />
            <span className="text-lg tracking-wide">{phone}</span>
          </a>

          <a
            href={`https://wa.me/${tel.replace("+", "")}`}
            target="_blank"
            rel="noreferrer"
            className="mt-3 flex items-center justify-center gap-2 text-sm text-emerald-300 hover:text-emerald-200 font-bold"
            data-testid="maintenance-whatsapp-button"
          >
            <Mail size={14} /> WhatsApp the developer
          </a>
        </div>

        <div className="mt-10 text-xs text-blue-300/70 inline-flex items-center gap-2">
          <Shield size={12} /> PMR Welfare Foundation · We United For A Brighter Tomorrow
        </div>
      </div>
    </div>
  );
}
